"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var vf_config_manager_1 = require("./util/vf-config-manager");
var logger_1 = require("./util/logger");
var dimensioningType;
(function (dimensioningType) {
    dimensioningType[dimensioningType["auto"] = 0] = "auto";
    dimensioningType[dimensioningType["millimeter"] = 1] = "millimeter";
})(dimensioningType || (dimensioningType = {}));
var VFModelDimension = (function () {
    function VFModelDimension(model, scene, measurementType) {
        if (measurementType === "millimeter") {
            this.measurementType = dimensioningType.millimeter;
        }
        else {
            this.measurementType = dimensioningType.auto;
        }
        if (!this.calculateBoundingBox(model)) {
            return;
        }
        this.scaleFactor = model.scaleFactor;
        function minimum(a, b) {
            if (a < b) {
                return a;
            }
            else {
                return b;
            }
        }
        var minExtend = minimum(this.extend.x, minimum(this.extend.y, this.extend.z));
        this.width = minExtend * 0.04;
        this.textHeight = minExtend * 0.15;
        this.spaceToText = minExtend * 0.025;
        this.spaceToBoundingBox = 0.05;
        this.yOffset = 0.001;
        this.arrowHeadScaling = 1;
        var fontSize = 160;
        this.labelFont = fontSize + "px Arial";
        this.labelTextureHeight = fontSize * 1.5;
        this.calculateLabelCenter();
        if (scene.getEngine().webGLVersion < 2) {
            this.createMeasureLabelsWebGl1(scene);
        }
        else {
            this.createMeasureLabels(scene);
        }
        this.createMeasurePlanes(scene);
        this.setRenderingGroup();
        this.setBillboardModeForY(this.yMeasurePlane);
        this.createObjectHierarchie(scene);
    }
    VFModelDimension.prototype.setBillboardModeForY = function (meshes) {
        var e_1, _a;
        try {
            for (var meshes_1 = __values(meshes), meshes_1_1 = meshes_1.next(); !meshes_1_1.done; meshes_1_1 = meshes_1.next()) {
                var current = meshes_1_1.value;
                current.billboardMode = babylonjs_1.Mesh.BILLBOARDMODE_Y;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (meshes_1_1 && !meshes_1_1.done && (_a = meshes_1.return)) _a.call(meshes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.yLabel.billboardMode = babylonjs_1.Mesh.BILLBOARDMODE_Y;
    };
    VFModelDimension.prototype.setRenderingGroup = function () {
        this.setRenderingGroupForMeshArray(this.xMeasurePlane);
        this.setRenderingGroupForMeshArray(this.yMeasurePlane);
        this.setRenderingGroupForMeshArray(this.yMeasureLines);
        this.setRenderingGroupForMeshArray(this.zMeasurePlane);
        this.xLabel.renderingGroupId = 1;
        this.yLabel.renderingGroupId = 1;
        this.zLabel.renderingGroupId = 1;
    };
    VFModelDimension.prototype.setRenderingGroupForMeshArray = function (meshes) {
        var e_2, _a;
        try {
            for (var meshes_2 = __values(meshes), meshes_2_1 = meshes_2.next(); !meshes_2_1.done; meshes_2_1 = meshes_2.next()) {
                var current = meshes_2_1.value;
                current.renderingGroupId = 1;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (meshes_2_1 && !meshes_2_1.done && (_a = meshes_2.return)) _a.call(meshes_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    VFModelDimension.prototype.createObjectHierarchie = function (scene) {
        this.modelDimension = new babylonjs_1.Mesh("modelDimension");
        this.xDimension = new babylonjs_1.Mesh("xDimension", scene, this.modelDimension);
        this.yDimension = new babylonjs_1.Mesh("yDimension", scene, this.modelDimension);
        this.zDimension = new babylonjs_1.Mesh("zDimension", scene, this.modelDimension);
        this.setObjectHierarchieForArray(this.xMeasurePlane, this.xDimension);
        this.xLabel.parent = this.xDimension;
        this.setObjectHierarchieForArray(this.yMeasurePlane, this.yDimension);
        this.setObjectHierarchieForArray(this.yMeasureLines, this.yDimension);
        this.yLabel.parent = this.yDimension;
        this.setObjectHierarchieForArray(this.zMeasurePlane, this.zDimension);
        this.zLabel.parent = this.zDimension;
    };
    VFModelDimension.prototype.setObjectHierarchieForArray = function (meshes, parent) {
        var e_3, _a;
        try {
            for (var meshes_3 = __values(meshes), meshes_3_1 = meshes_3.next(); !meshes_3_1.done; meshes_3_1 = meshes_3.next()) {
                var current = meshes_3_1.value;
                current.parent = parent;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (meshes_3_1 && !meshes_3_1.done && (_a = meshes_3.return)) _a.call(meshes_3);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    VFModelDimension.prototype.createMeasurePlanes = function (scene) {
        var arrowMaterial = new babylonjs_1.PBRMaterial("Arrow Material", scene);
        var arrowTexture = new babylonjs_1.Texture(vf_config_manager_1.default.GetConfig().arrowImageURL, scene);
        arrowTexture.hasAlpha = true;
        arrowMaterial.albedoTexture = arrowTexture;
        arrowMaterial.useAlphaFromAlbedoTexture = true;
        arrowMaterial.alphaMode = 2;
        arrowMaterial.unlit = true;
        var arrowHeadUV = new babylonjs_1.Vector4(0, 0.5, 0.5, 1);
        var arrowLineUV = new babylonjs_1.Vector4(0.5, 0, 1, 1);
        var transparent = new babylonjs_1.Vector4(0, 0, 0, 0);
        this.xMeasurePlane = [];
        var xLeft = [
            new babylonjs_1.Vector3(this.max.x, this.yOffset, this.max.z),
            new babylonjs_1.Vector3(this.max.x, this.yOffset, this.max.z + this.textHeight + this.spaceToBoundingBox),
        ];
        var xLeftLine = babylonjs_1.MeshBuilder.CreateLines("xLeftLine", { points: xLeft });
        xLeftLine.color = babylonjs_1.Color3.Black();
        this.xMeasurePlane.push(xLeftLine);
        var xRight = [
            new babylonjs_1.Vector3(this.min.x, this.yOffset, this.max.z),
            new babylonjs_1.Vector3(this.min.x, this.yOffset, this.max.z + this.textHeight + this.spaceToBoundingBox),
        ];
        var xRightLine = babylonjs_1.MeshBuilder.CreateLines("xRightLine", { points: xRight });
        xRightLine.color = babylonjs_1.Color3.Black();
        this.xMeasurePlane.push(xRightLine);
        var xLeftArrow = babylonjs_1.MeshBuilder.CreatePlane("xLeftArrowHead", {
            sideOrientation: babylonjs_1.Mesh.DOUBLESIDE,
            frontUVs: arrowHeadUV,
            backUVs: transparent,
        });
        xLeftArrow.scaling.x = this.arrowHeadScaling * this.width;
        xLeftArrow.scaling.y = this.width;
        xLeftArrow.position = this.xLabelCenter.clone();
        xLeftArrow.position.x = this.max.x - 0.5 * this.width;
        xLeftArrow.rotation.x = Math.PI * 0.5;
        xLeftArrow.rotation.z = -Math.PI * 0.5;
        xLeftArrow.material = arrowMaterial;
        this.xMeasurePlane.push(xLeftArrow);
        var xLeftArrowLine = babylonjs_1.MeshBuilder.CreatePlane("xLeftArrowLine", {
            sideOrientation: babylonjs_1.Mesh.DOUBLESIDE,
            frontUVs: arrowLineUV,
            backUVs: transparent,
        });
        xLeftArrowLine.scaling.y = 0.5 * (this.extend.x - 2 * this.width - this.xLabelWidth) - this.spaceToText;
        xLeftArrowLine.scaling.x = this.width;
        xLeftArrowLine.position = this.xLabelCenter.clone();
        xLeftArrowLine.position.x = this.max.x - this.width - 0.5 * xLeftArrowLine.scaling.y;
        xLeftArrowLine.rotation.x = Math.PI * 0.5;
        xLeftArrowLine.rotation.z = -Math.PI * 0.5;
        xLeftArrowLine.material = arrowMaterial;
        this.xMeasurePlane.push(xLeftArrowLine);
        var xRightArrowLine = xLeftArrowLine.clone("xRightArrowLine");
        xRightArrowLine.position.x = this.min.x + this.width + 0.5 * xRightArrowLine.scaling.y;
        this.xMeasurePlane.push(xRightArrowLine);
        var xRightArrow = xLeftArrow.clone("xRightArrowHead");
        xRightArrow.position.x = this.min.x + 0.5 * this.width;
        xRightArrow.rotation.z = Math.PI * 0.5;
        this.xMeasurePlane.push(xRightArrow);
        this.yMeasurePlane = [];
        this.yMeasureLines = [];
        var yBot = [
            new babylonjs_1.Vector3(this.max.x, this.min.y + this.yOffset, this.min.z),
            new babylonjs_1.Vector3(this.yLabelCenter.clone().x + 0.5 * this.textHeight, this.min.y + this.yOffset, this.yLabelCenter.clone().z - 0.5 * this.textHeight),
        ];
        var yBottomLine = babylonjs_1.MeshBuilder.CreateLines("yBottomLine", { points: yBot });
        yBottomLine.color = babylonjs_1.Color3.Black();
        this.yMeasureLines.push(yBottomLine);
        var yTop = [
            new babylonjs_1.Vector3(this.max.x, this.max.y, this.min.z),
            new babylonjs_1.Vector3(this.yLabelCenter.clone().x + 0.5 * this.textHeight, this.max.y, this.yLabelCenter.clone().z - 0.5 * this.textHeight),
        ];
        var yTopLine = babylonjs_1.MeshBuilder.CreateLines("yTopLine", { points: yTop });
        yTopLine.color = babylonjs_1.Color3.Black();
        this.yMeasureLines.push(yTopLine);
        var yBottomArrow = xLeftArrow.clone("yBottomArrowHead");
        yBottomArrow.rotation.x = 0;
        yBottomArrow.rotation.z = Math.PI;
        yBottomArrow.position = this.yLabelCenter.clone();
        yBottomArrow.position.y = this.min.y + 0.5 * this.width;
        this.yMeasurePlane.push(yBottomArrow);
        var yBottomArrowLine = babylonjs_1.MeshBuilder.CreatePlane("yBottomArrowLine", {
            sideOrientation: babylonjs_1.Mesh.DOUBLESIDE,
            frontUVs: arrowLineUV,
            backUVs: transparent,
        });
        yBottomArrowLine.position = this.yLabelCenter.clone();
        yBottomArrowLine.scaling.x = this.width;
        yBottomArrowLine.scaling.y = 0.5 * (this.extend.y - 2 * this.width - this.yLabelWidth) - this.spaceToText;
        yBottomArrowLine.position.y = this.min.y + this.width + 0.5 * yBottomArrowLine.scaling.y;
        yBottomArrowLine.material = arrowMaterial;
        this.yMeasurePlane.push(yBottomArrowLine);
        var yTopArrowLine = yBottomArrowLine.clone("yTopArrowLine");
        yTopArrowLine.position.y = this.max.y - this.width - 0.5 * yTopArrowLine.scaling.y;
        this.yMeasurePlane.push(yTopArrowLine);
        var yTopArrow = yBottomArrow.clone("yTopArrowHead");
        yTopArrow.rotation.z = 0;
        yTopArrow.position.y = this.max.y - 0.5 * this.width;
        this.yMeasurePlane.push(yTopArrow);
        this.zMeasurePlane = [];
        var zLeft = [
            new babylonjs_1.Vector3(this.max.x, this.yOffset, this.min.z),
            new babylonjs_1.Vector3(this.max.x + this.spaceToBoundingBox + this.textHeight, this.yOffset, this.min.z),
        ];
        var zLeftLine = babylonjs_1.MeshBuilder.CreateLines("zLeftLine", { points: zLeft });
        zLeftLine.color = babylonjs_1.Color3.Black();
        this.zMeasurePlane.push(zLeftLine);
        var zRight = [
            new babylonjs_1.Vector3(this.max.x, this.yOffset, this.max.z),
            new babylonjs_1.Vector3(this.max.x + this.spaceToBoundingBox + this.textHeight, this.yOffset, this.max.z),
        ];
        var zRightLine = babylonjs_1.MeshBuilder.CreateLines("zRightLine", { points: zRight });
        zRightLine.color = babylonjs_1.Color3.Black();
        this.zMeasurePlane.push(zRightLine);
        var zLeftArrow = xLeftArrow.clone("zLeftArrowHead");
        zLeftArrow.position = this.zLabelCenter.clone();
        zLeftArrow.position.z = this.min.z + 0.5 * this.width;
        zLeftArrow.rotation.z = Math.PI;
        this.zMeasurePlane.push(zLeftArrow);
        var zLeftArrowLine = xLeftArrowLine.clone("zLeftArrowLine");
        zLeftArrowLine.scaling.y = 0.5 * (this.extend.z - 2 * this.width - this.zLabelWidth) - this.spaceToText;
        zLeftArrowLine.position = this.zLabelCenter.clone();
        zLeftArrowLine.position.z = this.min.z + this.width + 0.5 * zLeftArrowLine.scaling.y;
        zLeftArrowLine.rotation.z = 0;
        this.zMeasurePlane.push(zLeftArrowLine);
        var zRightArrowLine = zLeftArrowLine.clone("zRightArrowLine");
        zRightArrowLine.position.z = this.max.z - this.width - 0.5 * zLeftArrowLine.scaling.y;
        this.zMeasurePlane.push(zRightArrowLine);
        var zRightArrow = zLeftArrow.clone("zRightArrowHead");
        zRightArrow.position.z = this.max.z - 0.5 * this.width;
        zRightArrow.rotation.z = 0;
        this.zMeasurePlane.push(zRightArrow);
    };
    VFModelDimension.prototype.getHumanReadableMeasurement = function (measurement) {
        var exponential = measurement.toExponential(1);
        var label;
        if (exponential.includes("e+3") || exponential.includes("e+4") || exponential.includes("e+5")) {
            label = (measurement / 1000).toFixed(1) + "km";
        }
        else if (exponential.includes("e-1") || exponential.includes("e-2")) {
            label = (measurement * 100).toFixed(1) + "cm";
        }
        else if (exponential.includes("e-3")) {
            label = (measurement * 1000).toFixed(1) + "mm";
        }
        else {
            label = measurement.toFixed(1) + "m";
        }
        return label;
    };
    VFModelDimension.prototype.getHumanReadableMeasurementInMillis = function (measurement) {
        return (measurement * 1000).toFixed(0) + "mm";
    };
    VFModelDimension.prototype.convertMeasurments = function () {
        var xMeasurement;
        var yMeasurement;
        var zMeasurement;
        switch (this.measurementType) {
            case dimensioningType.millimeter:
                xMeasurement = this.getHumanReadableMeasurementInMillis(this.extend.x / this.scaleFactor);
                yMeasurement = this.getHumanReadableMeasurementInMillis(this.extend.y / this.scaleFactor);
                zMeasurement = this.getHumanReadableMeasurementInMillis(this.extend.z / this.scaleFactor);
                break;
            case dimensioningType.auto:
                xMeasurement = this.getHumanReadableMeasurement(this.extend.x / this.scaleFactor);
                yMeasurement = this.getHumanReadableMeasurement(this.extend.y / this.scaleFactor);
                zMeasurement = this.getHumanReadableMeasurement(this.extend.z / this.scaleFactor);
                break;
            default:
                xMeasurement = this.getHumanReadableMeasurement(this.extend.x / this.scaleFactor);
                yMeasurement = this.getHumanReadableMeasurement(this.extend.y / this.scaleFactor);
                zMeasurement = this.getHumanReadableMeasurement(this.extend.z / this.scaleFactor);
                break;
        }
        return { x: xMeasurement, y: yMeasurement, z: zMeasurement };
    };
    VFModelDimension.prototype.createMeasureLabels = function (scene) {
        var convertMeasurements = this.convertMeasurments();
        var temp;
        temp = this.createMeasureLabel(scene, convertMeasurements.x, this.xLabelCenter.clone(), "xLabel");
        this.xLabel = temp.label;
        this.xLabelWidth = temp.width;
        this.xLabel.rotation.x = Math.PI * 0.5;
        this.xLabel.rotation.y = Math.PI;
        temp = this.createMeasureLabel(scene, convertMeasurements.y, this.yLabelCenter.clone(), "yLabel");
        this.yLabel = temp.label;
        this.yLabel.rotation.z = Math.PI * 0.5;
        this.yLabelWidth = temp.width;
        temp = this.createMeasureLabel(scene, convertMeasurements.z, this.zLabelCenter.clone(), "zLabel");
        this.zLabel = temp.label;
        this.zLabelWidth = temp.width;
        this.zLabel.rotation.x = Math.PI * 0.5;
        this.zLabel.rotation.y = -Math.PI * 0.5;
    };
    VFModelDimension.prototype.createMeasureLabelsWebGl1 = function (scene) {
        var convertMeasurements = this.convertMeasurments();
        var temp;
        temp = this.createMeasureLabelWebGl1(scene, convertMeasurements.x, this.xLabelCenter.clone(), "xLabel");
        this.xLabel = temp.label;
        this.xLabelWidth = temp.width;
        this.xLabel.rotation.x = Math.PI * 0.5;
        this.xLabel.rotation.y = Math.PI;
        temp = this.createMeasureLabelWebGl1(scene, convertMeasurements.y, this.yLabelCenter.clone(), "yLabel");
        this.yLabel = temp.label;
        this.yLabel.rotation.z = Math.PI * 0.5;
        this.yLabelWidth = temp.width;
        temp = this.createMeasureLabelWebGl1(scene, convertMeasurements.z, this.zLabelCenter.clone(), "zLabel");
        this.zLabel = temp.label;
        this.zLabelWidth = temp.width;
        this.zLabel.rotation.x = Math.PI * 0.5;
        this.zLabel.rotation.y = -Math.PI * 0.5;
    };
    VFModelDimension.prototype.createMeasureLabel = function (scene, measurement, position, name) {
        var temp = new babylonjs_1.DynamicTexture("DynamicTexture", 64, scene, true);
        var tempContext = temp.getContext();
        tempContext.font = this.labelFont;
        var DTWidth = tempContext.measureText(measurement).width;
        var planeHeight = this.textHeight;
        var DTHeight = this.labelTextureHeight;
        var ratio = planeHeight / DTHeight;
        var planeWidth = DTWidth * ratio;
        var dynamicTexture = new babylonjs_1.DynamicTexture(name + " Texture", { width: DTWidth, height: DTHeight }, scene, true);
        dynamicTexture.hasAlpha = true;
        var mat = new babylonjs_1.PBRMaterial(name + " Material", scene);
        mat.albedoTexture = dynamicTexture;
        mat.unlit = true;
        mat.useAlphaFromAlbedoTexture = true;
        mat.alphaMode = 2;
        dynamicTexture.drawText(measurement, null, null, this.labelFont, "#000000", "transparent", true);
        var label = babylonjs_1.MeshBuilder.CreatePlane(name, { width: planeWidth, height: planeHeight }, scene);
        label.position = position;
        label.material = mat;
        label.material.alpha = 1;
        return { label: label, width: planeWidth };
    };
    VFModelDimension.prototype.createMeasureLabelWebGl1 = function (scene, measurement, position, name) {
        var temp = new babylonjs_1.DynamicTexture("DynamicTexture", 64, scene, true);
        var tempContext = temp.getContext();
        tempContext.font = this.labelFont;
        var DTWidth = tempContext.measureText(measurement).width;
        var planeHeight = this.textHeight;
        var DTHeight = this.labelTextureHeight;
        var ratio = planeHeight / DTHeight;
        var planeWidth = DTWidth * ratio;
        var textureSizePOT = 512;
        while (textureSizePOT < DTWidth || textureSizePOT < DTHeight) {
            textureSizePOT *= 2;
        }
        var xMin = (textureSizePOT - DTWidth) * 0.5;
        var yMin = (textureSizePOT - DTHeight) * 0.5;
        var xMax = (textureSizePOT - xMin) / textureSizePOT;
        var yMax = (textureSizePOT - yMin) / textureSizePOT;
        xMin /= textureSizePOT;
        yMin /= textureSizePOT;
        var labelUVs = new babylonjs_1.Vector4(xMin, yMin, xMax, yMax);
        var transparent = new babylonjs_1.Vector4(0, 0, 0, 0);
        var dynamicTexture = new babylonjs_1.DynamicTexture(name + " Texture", { width: textureSizePOT, height: textureSizePOT }, scene, true);
        dynamicTexture.hasAlpha = true;
        var mat = new babylonjs_1.PBRMaterial(name + " Material", scene);
        mat.albedoTexture = dynamicTexture;
        mat.unlit = true;
        mat.useAlphaFromAlbedoTexture = true;
        mat.alphaMode = 2;
        dynamicTexture.drawText(measurement, null, null, this.labelFont, "#000000", "transparent", true);
        var label = babylonjs_1.MeshBuilder.CreatePlane(name, {
            width: planeWidth,
            height: planeHeight,
            sideOrientation: babylonjs_1.Mesh.DOUBLESIDE,
            frontUVs: labelUVs,
            backUVs: transparent,
        }, scene);
        label.position = position;
        label.material = mat;
        label.material.alpha = 1;
        return { label: label, width: planeWidth };
    };
    VFModelDimension.prototype.calculateLabelCenter = function () {
        this.xLabelCenter = new babylonjs_1.Vector3(this.max.x - this.extend.x * 0.5, this.yOffset, this.max.z + 0.5 * this.textHeight + this.spaceToBoundingBox);
        var offset = 0.5 * Math.sqrt(0.5 * Math.pow(this.textHeight + this.spaceToBoundingBox, 2));
        this.yLabelCenter = new babylonjs_1.Vector3(this.max.x + offset, this.min.y + this.extend.y * 0.5, this.min.z - offset);
        this.zLabelCenter = new babylonjs_1.Vector3(this.max.x + 0.5 * this.textHeight + this.spaceToBoundingBox, this.yOffset, this.max.z - this.extend.z * 0.5);
    };
    VFModelDimension.prototype.calculateBoundingBox = function (model) {
        var e_4, _a, e_5, _b, e_6, _c, e_7, _d;
        function excludeGroundPlane(mesh) {
            if (mesh.name.toLowerCase() === "plane") {
                return false;
            }
            else if (mesh.name.toLowerCase() === "plane-shadow") {
                return false;
            }
            else if (mesh.name.toLowerCase().includes("shadow-plane")) {
                return false;
            }
            else if (mesh.name.toLowerCase().includes("__floor_ao")) {
                return false;
            }
            else {
                return true;
            }
        }
        var node0;
        var contentRoot = model.getContentRoot();
        if (contentRoot) {
            node0 = contentRoot;
        }
        else {
            var rootNodes = model.getRoot().getChildren();
            try {
                for (var rootNodes_1 = __values(rootNodes), rootNodes_1_1 = rootNodes_1.next(); !rootNodes_1_1.done; rootNodes_1_1 = rootNodes_1.next()) {
                    var child = rootNodes_1_1.value;
                    if (child.name === "node0") {
                        node0 = child;
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (rootNodes_1_1 && !rootNodes_1_1.done && (_a = rootNodes_1.return)) _a.call(rootNodes_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        if (!node0) {
            logger_1.default.error("Cant Calculate Dimensioning, due to invalid scene hierarchy. model-version: " + model.version + " model-format: " + model.format);
            return false;
        }
        var bounding_vectors = {
            min: new babylonjs_1.Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE),
            max: new babylonjs_1.Vector3(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE),
        };
        var hasSurrogateRoot = false;
        var hasCustomEnvironment = false;
        try {
            for (var _e = __values(node0.getChildren()), _f = _e.next(); !_f.done; _f = _e.next()) {
                var child = _f.value;
                if (child.name === "surrogateRoot") {
                    hasSurrogateRoot = true;
                }
                else if (child.name === "CustomEnvironment") {
                    hasCustomEnvironment = true;
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_5) throw e_5.error; }
        }
        if (hasSurrogateRoot) {
            try {
                for (var _g = __values(node0.getChildren()), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var child = _h.value;
                    if (child.name === "surrogateRoot") {
                        bounding_vectors = child.getHierarchyBoundingVectors(true, excludeGroundPlane);
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        else if (hasCustomEnvironment) {
            try {
                for (var _j = __values(node0.getChildren()), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var child = _k.value;
                    if (child.name !== "CustomEnvironment") {
                        var temp = child.getHierarchyBoundingVectors(true, excludeGroundPlane);
                        bounding_vectors.min = babylonjs_1.Vector3.Minimize(temp.min, bounding_vectors.min);
                        bounding_vectors.max = babylonjs_1.Vector3.Maximize(temp.max, bounding_vectors.max);
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_d = _j.return)) _d.call(_j);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
        else {
            bounding_vectors = model.getRoot().getHierarchyBoundingVectors(true, excludeGroundPlane);
        }
        this.min = bounding_vectors.min;
        this.max = bounding_vectors.max;
        this.extend = new babylonjs_1.Vector3(this.max.x - this.min.x, this.max.y - this.min.y, this.max.z - this.min.z);
        return true;
    };
    return VFModelDimension;
}());
exports.default = VFModelDimension;
